import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";

// Page Components
import Home from "./pages/Home";
import Services from "./pages/Services";
import Industries from "./pages/Industries";
import Resources from "./pages/Resources";
import Products from "./pages/Products";
import About from "./pages/About";
import FoundersProgram from "./pages/FoundersProgram";
import Footer from "./components/Footer";
import Hospitality from "./pages/industries/Hospitality";
import Education from "./pages/industries/Education";
import Entertainment from "./pages/industries/Entertainment";
import Fintech from "./pages/industries/Fintech";
import SupplyChain from "./pages/industries/SupplyChain";
import Government from "./pages/industries/Government";
import Healthcare from "./pages/industries/Healthcare";
import Agriculture from "./pages/industries/Agriculture";
import CloudOptimization from "./pages/services/CloudOptimization";
import ApplicationDevelopment from "./pages/services/ApplicationDevelopment";
import DataAndAnalyticalSolutions from "./pages/services/DataAndAnalyticalSolutions";
import DevSecops from "./pages/services/DevSecops";
import ProductDevelopment from "./pages/services/ProductDevelopment";
import QualityAssurance from "./pages/services/QualityAssurance";
import StaffAugumentation from "./pages/services/StaffAugumentation";
import Contact from "./pages/Contact";
import UxUiDesigning from "./pages/services/UxUiDesigning";
import ScrollToTop  from "./pages/ScrollToTop";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Careers from "./pages/Careers";
import ScrollToTopButton from "./pages/ScrollToTopButton";
import WhatsappButton from "./pages/WhatsappButton";
import Blogs from "./pages/Blogs";
import AutomationTransformsSoftware from "./pages/blogs/AutomationTransformsSoftware";
import AutomatingApplicationDevelopment from "./pages/blogs/AutomatingApplicationDevelopment";
import CloudNativeServices from "./pages/blogs/CloudNativeServices";
import ModernApplicationDevelopment from "./pages/blogs/ModernApplicationDevelopment";
import AOS from "aos";
import "aos/dist/aos.css";
import AIsolutions from "./pages/services/AIsolutions";
import BuildingSmarterApps from "./pages/blogs/BuildingSmarterApps";




const App = () => {


useEffect(() => {
  AOS.init({
    once: false, 
  });
}, []);
  
  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      {/* <ScrollToTop /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />

        <Route
          path="/services/CloudOptimization"
          element={<CloudOptimization />}
        />

        <Route
          path="/services/ApplicationDevelopment"
          element={<ApplicationDevelopment />}
        />
        <Route
          path="/services/DataAndAnalyticalSolutions"
          element={<DataAndAnalyticalSolutions />}
        />
        <Route path="/services/DevSecops" element={<DevSecops />} />
        <Route
          path="/services/ProductDevelopment"
          element={<ProductDevelopment />}
        />
        <Route
          path="/services/QualityAssurance"
          element={<QualityAssurance />}
        />
        <Route
          path="/services/StaffAugumentation"
          element={<StaffAugumentation />}
        />
        <Route path="/services/UxUiDesigning" element={<UxUiDesigning />} />
        <Route path="/services/AIsolutions" element={<AIsolutions />} />

        <Route path="/industries" element={<Industries />} />

        <Route path="/industries/Hospitality" element={<Hospitality />} />
        <Route path="/industries/Education" element={<Education />} />
        <Route path="/industries/Entertainment" element={<Entertainment />} />
        <Route path="/industries/Fintech" element={<Fintech />} />
        <Route path="/industries/Government" element={<Government />} />
        <Route path="/industries/SupplyChain" element={<SupplyChain />} />
        <Route path="/industries/Healthcare" element={<Healthcare />} />
        <Route path="/industries/Agriculture" element={<Agriculture />} />

        <Route path="/resources" element={<Resources />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/founders-program" element={<FoundersProgram />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route
          path="/blogs/AutomationTransformsSoftware"
          element={<AutomationTransformsSoftware />}
        />
        <Route
          path="/blogs/AutomatingApplicationDevelopment"
          element={<AutomatingApplicationDevelopment />}
        />
        <Route
          path="/blogs/CloudNativeServices"
          element={<CloudNativeServices />}
        />
        <Route
          path="/blogs/ModernApplicationDevelopment"
          element={<ModernApplicationDevelopment />}
        />
        <Route
          path="/blogs/BuildingSmarterApps"
          element={<BuildingSmarterApps />}
        />

        <Route path="/careers" element={<Careers />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
      </Routes>
      {/* <WhatsappButton /> */}
      <ScrollToTopButton />
      <Footer />
    </Router>
  );
};

export default App;
